import './App.css';
import React, { Component } from "react";

class App extends Component {

  // Variables

  // Début compteur 1300
  // Fin compteur 60000

  // MAX FRAME 61695 et pas 61696!!

  minFrame = 1300
  maxFrame = 60000

  // let testFrame = 30848

  // Mettre floor et pas round, car mon test compare la testFrame avec la maxFrame, donc prendre l'arrondi du dessus
  initialRandomTestFrame = Math.floor(Math.random() * (this.maxFrame - this.minFrame + 1)) + this.minFrame

  correctFrame = 39556


  state = {
    minFrame: 1300,
    maxFrame: 60000,

    // Mettre floor et pas round, car mon test compare la testFrame avec la maxFrame, donc prendre l'arrondi du dessus
    testFrame: Math.floor(Math.random() * (this.maxFrame - this.minFrame + 1)) + this.minFrame,

    frameFound: false,

    showHelp: false
  }

  clickYes = () => {
    let newMaxFrame = this.state.testFrame;
    this.setState({ maxFrame: newMaxFrame });
    let newTestFrame = Math.round(newMaxFrame - ((newMaxFrame - this.state.minFrame) / 2))
    this.setState({ testFrame: newTestFrame });
    // console.log('New Test Frame', newTestFrame)
    // console.log('New Min Frame', this.state.minFrame)
    // console.log('New Max Frame', this.state.maxFrame)

    // End test
    if (this.state.testFrame === this.state.maxFrame) {
      this.setState({ frameFound: true });
    }
  }


  // Clic sur No
  clickNo = () => {
    let newMinFrame = this.state.testFrame;
    this.setState({ minFrame: newMinFrame });
    let newTestFrame = Math.round(newMinFrame + ((this.state.maxFrame - newMinFrame) / 2))
    this.setState({ testFrame: newTestFrame });
    // console.log('New Test Frame', newTestFrame)
    // console.log('New Min Frame', this.state.minFrame)
    // console.log('New Max Frame', this.state.maxFrame)

    // End test
    if (this.state.testFrame === this.state.maxFrame) {
      this.setState({ frameFound: true });
    }
  }


  // Show Help Modal Window
  showHelp = () => {
    this.setState({ showHelp: true });
  }

  // Close Help Modal Window
  closeHelp = () => {
    this.setState({ showHelp: false });
  }

  // Restart the game, resetting all the state
  restartGame = () => {
    this.setState({ minFrame: 1300, maxFrame: 60000, testFrame: Math.floor(Math.random() * (this.maxFrame - this.minFrame + 1)) + this.minFrame, frameFound: false });
    // console.log('Restart Min Frame', this.state.minFrame)
    // console.log('Restart Max Frame', this.state.maxFrame)
    // console.log('Restart Test Frame', this.state.testFrame)
  }


  render() {

    return (
      <div className="App">
        <div className="container">
          <div className="row">

            {/* Image */}
            <img className="image col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" src={`https://framex-dev.wadrid.net/api/video/Falcon%20Heavy%20Test%20Flight%20(Hosted%20Webcast)-wbSwFU6tY1c/frame/${this.state.testFrame}`} alt="Rocket Launch" srcSet="" />
          </div>

          <br />

          {/* Boutons primaires */}
          <div className="row col-sm-8 justify-content-evenly">

            {/* Button Yes */}
            <button className="btn btn-success col-3" onClick={this.clickYes}>Yes</button>

            {/* Button No */}
            <button className="btn btn-danger col-3" onClick={this.clickNo}>No</button>
          </div>

          <br />

          {/* Boutons secondaires */}
          <div className="row">

            <div className="col-sm-8 text-center">

              {/* Button Restart */}
              <button className="btn btn-secondary" onClick={this.restartGame}>Restart</button>

              {/* Button Help */}
              <button className="btn btn-info" onClick={this.showHelp}>Help</button>
            </div>
          </div>

          <br />

          {/* Résultat apparaissant une fois l'image trouvée */}
          <div className={`col-sm-8 text-center fw-bold ${this.state.testFrame === this.correctFrame ? 'text-success' : 'text-danger'}`}>
            
            {(this.state.frameFound && <p>Frame found: {this.state.maxFrame}{this.state.testFrame === this.correctFrame ? '. Correct answer!' : '. Sorry, that is not the right answer.'}</p>)}
          </div>

          {/* Modal Help */}
          {this.state.showHelp && <section className="modulHelp" onClick={this.closeHelp}>
            <div className="okHelp">
              <p style={{ fontWeight: "bold" }}>When did the rocket launch?</p>
              <p>Welcome to the "When did the rocket launch?" application!</p>
              <p>The goal of this application is to find the exact frame in a video when the rocket of a SpaceX mission launches. You can check the timer at the top right corner of the images to see if the rocket has launched yet or not. For this, just verify if there is a minus "-" symbol or a plus "+" on the timer.</p>
              <p>Click Yes or No to answer if the rocket has launched yet or not.</p>
              <p>The exact frame of the launch should be found in 16 steps. The game ends when this frame is found and its number is revealed to you.<br />
              Ready?</p>
              <p>Thank you for visiting FSidibe.com!</p>
            </div>
          </section>}

        </div>
      </div >
    );
  }
}

export default App;

